/* global ADV */

const {
  settings: {
    endpoints: { adviserImagesDir },
  },
} = ADV;

export default fileName => `${adviserImagesDir}${fileName}`;
